var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M43.15,19.19l-0.32,0.97c-0.14,0.42-0.74,0.43-0.89,0.01l-0.24-0.69c-0.25-0.74-0.95-1.23-1.73-1.23h-4.31 c-1.16,0-2.2-0.73-2.59-1.82l-0.77-2.15c-0.52-1.46-1.9-2.43-3.45-2.43h-3.14c-0.51,0-0.92-0.41-0.92-0.92v-0.23 c0-0.51,0.41-0.92,0.92-0.92h2.99c0.88,0,1.59-0.71,1.59-1.59V8.16c0-0.88-0.71-1.59-1.59-1.59H18.38c-0.88,0-1.59,0.71-1.59,1.59 v0.03c0,0.88,0.71,1.59,1.59,1.59h2.99c0.51,0,0.92,0.41,0.92,0.92v0.23c0,0.51-0.41,0.92-0.92,0.92h-2.05 c-0.58,0-1.13,0.28-1.47,0.74l-2.11,2.86c-0.35,0.47-0.89,0.74-1.47,0.74H8.56c-1.52,0-2.75,1.23-2.75,2.75v5.64 c0,0.51-0.41,0.92-0.92,0.92H4.36c-0.51,0-0.92-0.41-0.92-0.92v-7.12c0-0.7-0.57-1.26-1.26-1.26H2.16c-0.7,0-1.26,0.57-1.26,1.26 v17.83c0,0.7,0.57,1.26,1.26,1.26h0.03c0.7,0,1.26-0.57,1.26-1.26v-7.12c0-0.51,0.41-0.92,0.92-0.92H4.9c0.51,0,0.92,0.41,0.92,0.92 v5.64c0,1.52,1.23,2.75,2.75,2.75h2.87c1.08,0,2.1,0.48,2.8,1.3l1.47,1.74c0.7,0.83,1.72,1.3,2.8,1.3h20.03 c1.52,0,2.75-1.23,2.75-2.75v-1.6c0-0.51,0.41-0.92,0.92-0.92h0.46c0.51,0,0.92,0.41,0.92,0.92v0.93c0,1,0.81,1.81,1.81,1.81h0.04 c1,0,1.81-0.81,1.81-1.81V19.75c0-1-0.81-1.81-1.81-1.81h-0.53C44.09,17.93,43.39,18.44,43.15,19.19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/51.b5fea228318af8fe0c7f3c657c1c9ae8.svg";
export { ForwardRef as ReactComponent };